import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BookingComponent} from "./booking.component";
import { BookingRouting } from "./booking.routing";
import { AgencyComponent } from './component/agency/agency.component';
import { CustomerComponent } from './component/customer/customer.component';
import { PriceComponent } from './component/price/price.component';
import { ReferenceComponent } from './component/reference/reference.component';
import { TravellerComponent } from './component/traveller/traveller.component';
import { QuoteDetailsComponent } from './component/price/quote-details/quote-details.component';
import { MatTabsModule } from "@angular/material/tabs";
import { PricePipeModule } from "libraries/pipes/price/price-pipe.module";
import { PricePipesModule } from "libraries/pipes/price/price-pipes.module";
import { BtnModule } from "libraries/ui_button/btn.module";
import { TextModule } from "libraries/module/formbuilder/fields/text/text.module";
import { DateModule } from "libraries/module/formbuilder/fields/date/date.module";
import { DateParserModule } from "libraries/service/date/dateParser.module";
import { NotificationModule } from "libraries/component/notification/notification.module";
import { NumberModule } from "libraries/module/formbuilder/fields/number/number.module";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import {
    IconNameToDefinitionModule
} from "libraries/pipes/icon-name-to-definition/icon-name-to-definition.module";
import { SimpleSelectModule } from "libraries/module/formbuilder/fields/simple-select/simple-select.module";
import { TextFieldModule } from "libraries/module/formbuilder/fields/text-field/text-field.module";
import { LoaderModule } from "libraries/component/loader/loader.module";
import { MailDialogComponent } from './component/mail-dialog/mail-dialog.component';
import { MatDialogModule } from "@angular/material/dialog";
import { SafePipe } from "app_watabilight/pages/booking/pipes/safe.pipe";
import { ModalLinkComponent } from './component/modal-link/modal-link.component';
import {
    SimpleTextareaFieldModule
} from "libraries/module/formbuilder/fields/simple-textarea-field/simple-textarea-field.module";
import { DatePipeModule } from "libraries/date/date.module";
import {
    TravellerDataTranslationModule
} from "libraries/service/traveller-data-translation/traveller-data-translation.module";
import {
    IsIdenticalPricesPipe
} from "app_watabilight/pages/booking/component/price/quote-details/is-identical-prices.pipe";
import { HasOneQuotePipe } from "app_watabilight/pages/booking/pipes/has-one-quote.pipe";
import { PriceDifferenceModule } from "libraries/price-difference/price-difference.module";
import { IsEditableFieldPipe } from "app_watabilight/pages/booking/component/agency/is-editable-field.pipe";
import { LabelModule } from "libraries/service/label/label.module";

@NgModule({
    imports: [
        BookingRouting,
        BtnModule,
        CommonModule,
        DateModule,
        DateParserModule,
        DatePipeModule,
        FontAwesomeModule,
        IconNameToDefinitionModule,
        LoaderModule,
        MatDialogModule,
        MatTabsModule,
        NotificationModule,
        NumberModule,
        PricePipeModule,
        PricePipesModule,
        SimpleSelectModule,
        SimpleTextareaFieldModule,
        TextFieldModule,
        TextModule,
        TravellerDataTranslationModule,
        PriceDifferenceModule,
        LabelModule,
    ],
    declarations: [
        AgencyComponent,
        BookingComponent,
        CustomerComponent,
        HasOneQuotePipe,
        IsIdenticalPricesPipe,
        MailDialogComponent,
        ModalLinkComponent,
        PriceComponent,
        QuoteDetailsComponent,
        ReferenceComponent,
        SafePipe,
        TravellerComponent,
        IsEditableFieldPipe,
    ]
})
export class BookingModule {}
